import React, { useState } from 'react'
import { CCol, CRow } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilChevronBottom, cilChevronTop } from '@coreui/icons'
import './table.css'
import { Link } from 'react-router-dom'

export const EMPLOYEE_TYPE_OFFICER = 1;
export const EMPLOYEE_TYPE_STAFF = 2;
export const EMPLOYEE_TYPE_WORKER = 3;

export const EMPLOYEE_TYPE_NAME = {
  1: 'Officer',
  2: 'Staff',
  3: 'Worker',
}

const getEmployeeTypeLabel = (employee) => {
  if (Number(employee?.designation?.is_officer) === 1) {
    return 'Officer'
  }

  const designationType = Number(employee?.designation?.type)

  if (designationType === 1) {
    return 'Staff'
  }

  if (designationType === 2) {
    return 'Worker'
  }

  if (designationType === 3) {
    return 'Daily Wager'
  }

  return EMPLOYEE_TYPE_NAME[Number(employee?.employee_type)] || '-'
}

export default function DataReportTable({ reportData, setReportData, formatDate }) {
  const [sortedKey, setSortedKey] = useState('')
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'asc',
  })
  const sortTable = (key) => {
    let direction = 'asc'
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc'
    }
    const sorted = [...reportData].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === 'asc' ? -1 : 1
      }
      if (a[key] > b[key]) {
        return direction === 'asc' ? 1 : -1
      }
      return 0
    })
    setReportData(sorted)
    setSortedKey(key)
    setSortConfig({ key, direction })
  }
  return (
    <>
      <thead className="thead-dark" style={{ backgroundColor: '#e8e9eb' }}>
        <tr>
          <th onClick={() => sortTable('id')}>Sr No.</th>
          <th onClick={() => sortTable('id')}>
            ID{' '}
            {sortedKey === 'id' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('full_name')}>
            Full Name
            {sortedKey === 'full_name' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('designation')}>
            Designation
            {sortedKey === 'designation' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('department')}>
            Department
            {sortedKey === 'department' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('branch')}>
            Branch
            {sortedKey === 'branch  ' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('date_of_joining')}>
            Date Of Joinig

            {sortedKey === 'date_of_joining' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('employee_type')}>
            Employment Type
            {sortedKey === 'employee_type' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('job_status')}>
            Job Status
            {sortedKey === 'job_status' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
        </tr>
      </thead>
      <tbody>
        {reportData.map((item, index) => (
          <tr key={item.id}>
            <td>{index + 1}</td>
            <td style={{ color: 'blue' }}>
              <Link
                to={`/employee-profile?id=${item.id}`}
                target="_blank"
              >
                {item.id}
              </Link>
            </td>
            <td style={{ color: 'blue' }}>
              <Link
                to={`/employee-profile?id=${item.id}`}
                target="_blank"
              >
                {item.full_name}
              </Link>
            </td>
            <td>{item.designation?.name}</td>
            <td>{item.department?.name}</td>
            <td>{item.branch?.name}</td>
            <td>{formatDate(item.date_of_joining)}</td>
            <td>{getEmployeeTypeLabel(item)}</td>
            <td>{item.job_status}</td>


          </tr>
        ))}
      </tbody>
    </>
  )
}
